const hpSlideShow = document.querySelectorAll('.slideshow-slider-link');
hpSlideShow?.forEach(function(slide) {
    slide.addEventListener('click', function() {
        const hrefValue = this.getAttribute('href') || "";
        const index = this.getAttribute('data-index') || "";
        const content = this.getAttribute('data-image') || "";
        
        gaEvent('main_banner', [index, hrefValue, content, '', '', ''], false);
    });
})

const footerNewsletter = document.querySelector('.form-sheet-submit-btn');

footerNewsletter?.addEventListener('click', function() {
    const newsLetterInputs = document.querySelectorAll('.newsletter-form__field-wrapper .footer-newsletter-input');
    const pincode = newsLetterInputs[0].value.trim();
    const phone = newsLetterInputs[1].value.trim();
    const errorMsg = document.querySelector('.error-message-text');

    const isValidPincode = /^\d{6}$/.test(pincode);
    const isValidPhone = /^\d{10}$/.test(phone);

    if (!isValidPincode) {
        errorMsg.innerHTML = 'Please enter a valid 6-digit pincode.';
        return; // Stop further execution
    }

    if (!isValidPhone) {
        errorMsg.innerHTML = 'Please enter a valid 10-digit phone number.';
        return; // Stop further execution
    }

    let eliteProductsArray = ["9020286992613", "9024321159397", "9024320700645" , "9584619782373", "9234386256101", "9584618504421"];
    let currentProductID = document.body.dataset.productId;
    let currentCollectionHandle = document.body.dataset.collectionHandle;
    let productTitle = document.body.dataset.productTitle || '';

    let productCategory = '';
    if(currentProductID) {
        if (eliteProductsArray.includes(currentProductID)) {
            productCategory = 'Elite Sofa';
        }
    }

    // Map to standardized Primary Product Category (using centralized function)
    const primaryProductCategory = window.getPrimaryProductCategory ? window.getPrimaryProductCategory(productCategory, productTitle, currentCollectionHandle, currentProductID) : '';

    fetch("https://apis.thesleepcompany.in/lead/datafeed", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            pincode: pincode,
            phone: phone,
            source: "Newsletter Community",
            lead_status: "Tier 1",
            activity_source: "Newsletter Community",
            activity_note: pincode,
            ...(productCategory && { product_type: productCategory }),  // Only include if productCategory is not empty
            ...(productCategory && { mx_custom_4: productCategory }),
            ...(primaryProductCategory && { mx_Primary_Product_Category: primaryProductCategory }),
            ...(primaryProductCategory && { activity_code: 208 }),
            ...(primaryProductCategory && { mx_custom_48: primaryProductCategory }),
            mx_mobile_device: getDeviceModel(),
            mx_mobile_os: getOSWithVersion(),
            is_web_engage_event: true,
            web_engage_data: {
                    product_category: productCategory,
                    pincode: pincode,
                    phone: phone,
                },
            ...(primaryProductCategory && { web_engage_user_data: { category: primaryProductCategory } }),
        }),
    })

    gaEvent('send_my_discount_code', ['send_my_discount_code', '',pincode,`+91${phone}`,'',''], false);
});
